var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('eventOverview')}}),_c('v-container',[_c('public-event-category-overview',{attrs:{"events":_vm.events}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }